'use client';

import React, { useState, useEffect } from 'react';

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Floating Book Button */}
      <div
        className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
        }`}
      >
        <a
          href="https://book.housecallpro.com/book/Gorgis-Air-conditioning-and-heating/8d64616590bd4fe49c1a93f43f1cbfae"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 bg-[#b5973a] hover:bg-[#d4aa4a] text-white font-poppins font-bold uppercase tracking-wider px-5 py-3 rounded-full text-sm shadow-2xl shadow-[#b5973a]/40 transition-all duration-300 book-btn-pulse"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          Book Now
        </a>
      </div>

      {/* Floating Phone Button */}
      <div
        className={`fixed bottom-6 left-6 z-50 transition-all duration-500 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
        }`}
      >
        <a
          href="tel:+16192773287"
          className="flex items-center gap-2 bg-[#252525] border-2 border-[#b5973a] hover:bg-[#b5973a] text-white font-poppins font-bold px-5 py-3 rounded-full text-sm shadow-2xl transition-all duration-300"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          Call Now
        </a>
      </div>

      {/* Back to top */}
      <div
        className={`fixed bottom-20 right-6 z-50 transition-all duration-500 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
        }`}
      >
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="w-11 h-11 rounded-full border-2 border-[#b5973a] text-[#b5973a] hover:bg-[#b5973a] hover:text-white flex items-center justify-center transition-all duration-300"
          aria-label="Back to top"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
          </svg>
        </button>
      </div>
    </>
  );
}
